import hdrm from '../../hdrm';

export default (...args) => hdrm.accessors.getStaticElement(...args);
